var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-404"},[_c('div',{staticClass:"content-card"},[_c('span',{staticClass:"text-status-error"},[_vm._v(" "+_vm._s(_vm.errorStateService.status)+" ")]),_c('h2',[_vm._v(" "+_vm._s(_vm.errorStateService.title)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.errorStateService.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }